package com.macrofocus.high_d.parallelcoordinates

import com.macrofocus.high_d.axis.AxisView
import org.mkui.component.CPComponent

/**
 * The components of an axis laid out by the parallel coordinates view, as SwingAxisComponents: its header, its range
 * slider and the labels of its maximum (above the slider) and minimum (below it).
 */
class DefaultAxisComponents<Row, Column>(
    private val label: CPComponent?,
    private val axisView: AxisView<Row, Column>,
    private val maxLabel: CPComponent? = null,
    private val minLabel: CPComponent? = null,
    /** The values of the end and the start of the range, shown while the mouse is over the slider. */
    val endBubble: RangeBubbleView? = null,
    val startBubble: RangeBubbleView? = null,
) : AxisComponents {
    /** Whether the mouse is over the slider. */
    var isSliderHovered: Boolean = false

    /** "Hide range slider" / "Show range slider" of the header popup menu. */
    var isSliderVisible: Boolean = true

    /** "Hide labels" / "Show labels" of the header popup menu. */
    var isLabelsVisible: Boolean = true

    fun getAxisView(): AxisView<Row, Column> = axisView

    fun getLabel(): CPComponent? = label

    fun getMinLabel(): CPComponent? = minLabel

    fun getMaxLabel(): CPComponent? = maxLabel

    /** Every component of the axis. */
    fun components(): List<CPComponent> = listOfNotNull(label, axisView, maxLabel, minLabel, endBubble, startBubble)

    fun dispose() {
        (label as? AxisHeaderView<*, *>)?.dispose()
        (maxLabel as? AxisLimitView<*, *>)?.dispose()
        (minLabel as? AxisLimitView<*, *>)?.dispose()
    }
}
